module.exports = __webpack_public_path__ + "img/icon-headset-vive.ec7d5935.png";